<template>
    <v-dialog
        v-model="dialog"
        fullscreen
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Edit Recipient</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="onClickDiscardChanges"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        dark
                        text
                        :disabled="!is_valid"
                        @click="onClickSave"
                    >
                        Save &amp; Close
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>

                <v-form
                    autocomplete="off"
                >
                    <v-container>
                        <m-autocomplete-phone-number
                            v-if="!intermediate_recipient.rc_is_valid"
                            label="Contacts"
                            autofocus
                            :organization_id="organization_id"
                            v-on:input="setEndpointValue"
                            :rules="[rules.required]"
                            ref="autocomplete-phone-number"
                        />
                        <v-text-field
                            v-else
                            label="Phone Number"
                            :value="prettyPrintNumber(intermediate_recipient.rc_phone_number)"
                            disabled
                            autocomplete="off"
                        />

                        <v-row
                            no-gutters
                        >
                            <v-col
                                cols="12"
                                sm="6"
                                style="padding-right: 15px"
                            >
                                <v-text-field
                                    label="First Name"
                                    v-model="intermediate_recipient.rc_first_name"
                                    autocomplete="off"
                                />
                            </v-col>

                            <v-col
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    label="Last Name"
                                    v-model="intermediate_recipient.rc_last_name"
                                    autocomplete="off"
                                />
                            </v-col>
                        </v-row>

                        <v-row
                            v-for="(value, name, index) in this.extra_fields"
                            v-bind:key="index"
                            no-gutters
                        >
                            <v-col
                                cols="12"
                                sm="6"
                                style="padding-right: 15px"
                            >
                                <v-text-field
                                    label="Column Name"
                                    :value="value"
                                    disabled
                                    autocomplete="off"
                                />
                            </v-col>

                            <v-col
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    label="Column Value"
                                    :value="getExtraFieldValue(name)"
                                    :index="index"
                                    v-on:input="updateColumnValue($event, name)"
                                    autocomplete="off"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
const { v4: uuidv4 } = require('uuid');
const E164 = require("@/js/E164.js");
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            organization_id: null,
            intermediate_recipient: {},
            original_recipient: {},
            extra_fields: {},

            rules: {
                required: (value) => { if ( value == null || value.trim().length == 0 ) return 'Required'; return true;  },
            },
        }
    },

    methods: {

        getExtraFieldValue(key)
        {
            return this.intermediate_recipient[key];
        },

        prettyPrintNumber(endpoint)
        {
            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        showExtraColumnInfo()
        {
            this.$rc.alert(
                'Extra Columns',
                'Any Extra Columns can be added to help keep track of leads, such as Date Entered, or Type of Product requested.'
            );
        },

        showDialog(organization_id, extra_fields, intermediate_recipient)
        {
            this.organization_id = organization_id;
            this.extra_fields = extra_fields;

            this.original_recipient = intermediate_recipient;
            this.intermediate_recipient = _.cloneDeep(intermediate_recipient);

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        setEndpointValue(new_endpoint)
        {
            if ( new_endpoint )
            {
                this.intermediate_recipient.rc_phone_number = new_endpoint.value;

                // if name is null, it's a new endpoint and a contact should be created
                let create_contact = new_endpoint.name === null;
                this.intermediate_recipient.rc_create_contact = create_contact;
            }
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                // data is valid, so save
                this.save();
                this.dialog = false;
                next();
                return;
            }

            this.$rc.snackbar('You must either correct the errors or discard your changes.',3500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        updateColumnValue(new_value, key)
        {
            this.intermediate_recipient[key] = new_value;
        },

        save()
        {
            // if it wasn't valid, update the new object to reflect the repaired state
            let update_to_manually_fixed = !this.original_recipient.rc_is_valid;

            if ( update_to_manually_fixed )
            {
                this.intermediate_recipient.rc_system_notes = 'Manually fixed';
                this.intermediate_recipient.rc_is_valid = true;
            }

            this.$emit('ok', this.intermediate_recipient);
        },
    },
    computed: {
        is_valid() {
            return this.intermediate_recipient != null
                && this.intermediate_recipient.rc_phone_number != null
                && this.intermediate_recipient.rc_phone_number != '';
        },
    },
}
</script>

<style lang="scss" scoped>
</style>